import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

export const verifyPayments = createAsyncThunk(
  "payment/verifypayment",
  async ({ paymentId, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/subscriptions/verify-payment/${paymentId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        toast.success("Payment verified successfully!");
        return response.data;
      } else {
        toast.error("Payment verification failed.");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const message = error?.response?.data?.message || "Payment verification failed.";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const subscription = createAsyncThunk(
  "payment/subscription",
  async ({ token, planId, frequency = 1 }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/subscriptions`,
        { planId: parseInt(planId), frequency },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        // toast.success("Subscription created successfully!");
        return response.data;
      } else {
        toast.error("Subscription failed.");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const message = error?.response?.data?.message || "Subscription failed.";
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    isLoading: false,
    error: null,
    success: false,
    data: null,
  },
  reducers: {
    resetPayment: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscription.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(subscription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(subscription.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(verifyPayments.pending, (state) => {

        state.error = null;
        state.success = false;
      })
      .addCase(verifyPayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(verifyPayments.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetPayment } = paymentSlice.actions;
export default paymentSlice.reducer;
